// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__cQ1C6","dragIcon":"Choice_dragIcon__nVx92","left":"Choice_left__1umzR","input":"Choice_input__1l5RP"};